<template>
  <div class="audLogin">
    <div class="max_login" v-if="regs">
      <div class="login_content">
        <div class="login_image">
          <p>{{loginTitle}}</p>
          <p>
            <img :src="require('../../assets/image/zhuc.png')" alt />
          </p>
        </div>
        <div class="login_main">
          <p class="ts">
            <span class="dian"></span>
            <span style="margin: 0 10px;">温馨提示</span>
            <span class="dian"></span>
          </p>
          <p>
            已完成注册的观众,请
            <span>【登录】</span>,进入观众中心
          </p>
          <p style="margin-top: 16px">
            尚未注册的观众,请点击
            <span>【个人注册】</span>,完成在线注册
          </p>
          <div class="login-container">
            <div class="container_title">
              观众登录
              <span></span>
            </div>
            <el-form ref="form" :model="loginForm" class="login-form" @keyup.enter.native="login">
              <div>
                <el-form-item label>
                  <el-input v-model="loginForm.phone" placeholder="请输手机号码"></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input type="password" v-model="loginForm.password" placeholder="请输入登录密码"></el-input>
                </el-form-item>
              </div>
              <el-button @click="login">登录</el-button>
              <div class="pass_span">
                <span @click="toRegister">注册</span>
                <span @click="toResetpwd">忘记密码</span>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <!--  -->
    <a-register @setRegs="setRegs" v-else></a-register>
  </div>
</template>

<script>
import ARegister from "./AudienceRegister";
export default {
  name: "audienceLogin",
  components: {
    ARegister
  },
  data() {
    return {
      loginForm: {
        //登录表单
        phone: "", // 信用代码
        password: ""
      },
      regs: true,
	  loginTitle:"",
    };
  },
  mounted() {
	  this.init();
  },
  methods: {
    login() {
      this.$http
        .post("viewer/login", {
          phone: this.loginForm.phone,
          password: this.loginForm.password
        })
        .then(response => {
          let { code } = response.data;
          if (code === 0) {
            let token = response.data.token;
            // sessionStorage.setItem("gzToken", token);
            this.$cookie.set("gzToken", token);
            this.$cookie.delete("mkToken");
            //保存token状态
            this.$store.commit("SET__TOKEN", token);
            //跳转到观众中心
            this.$router.push("audienceCenter");
          } else {
            this.$message.error(response.data.msg);
          }
        })
        .catch(error => console.log(error));
    },
    // 忘记密码
    toResetpwd() {
      this.$router.push({
        path: "/resetpwd",
        query: {
          url: "/audLogin"
        }
      });
    },
    // 注册
    toRegister() {
      this.regs = false;
    },
    // 更改regs
    setRegs() {
      this.regs = true;
    },
	
	//登录页标题与温暖馨提示
	init() {
	  this.$http({
	    url: "getScheduleTitle",
	    method: "get",
	  }).then(({ data }) => {
	    let {msg, code, runSchedule } = data;
	    if (code === 0) {
		  if(runSchedule.runStatus === "1"){
			  this.loginTitle = runSchedule.name;
		  }
	    } else {
	      //this.$message.error(msg);
		  this.loginTitle = msg;
	    }
	  });
	}
	
  },
  beforeRouteLeave(to,form,next) {
    this.regs = true;
    next();
  }
};
</script>

<style lang="scss">
.audLogin {
  .el-input__inner {
    height: 52px;
    line-height: 52px;
    border-radius: 4px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss" scoped>
.audLogin {
  width: 100%;
  min-height: 582px;
  margin: 0 auto 114px;
  //   overflow: hidden;
  .max_login {
    width: 1200px;
    height: 582px;
    margin: 0 auto;
    .login_content {
      width: 100%;
      height: 687px;
      .login_image {
        width: 670px;
        height: 489px;
        margin-top: 82px;
        float: left;
        text-align: center;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
        p:first-child {
          margin-bottom: 78px;
        }
      }
      .login_main {
        width: 444px;
        height: 496px;
        float: right;
        margin-top: 82px;
        .ts {
          color: #278dfe;
          text-align: center;
          margin-bottom: 20px;
          span {
            float: left;
          }
          span:first-child {
            margin-left: 172px;
          }
        }
        .dian {
          display: block;
          width: 6px;
          height: 6px;
          background-color: #278dfe;
          border-radius: 50%;
          float: left;
          margin-top: 4px;
        }
        p {
          height: 14px;
          font-size: 14px;
          line-height: 14px;
          text-align: center;
        }
        .login-container {
          width: 364px;
          height: 309px;
          box-shadow: 0px 0px 30px 8px #f3f3f3;
          margin-top: 22px;
          padding: 37px 40px 54px 40px;
          .container_title {
            width: 350px;
            font-size: 18px;
            color: #143372;
            border-bottom: 1px solid #e5e5e5;
            line-height: 42px;
            margin-bottom: 31px;
            position: relative;
            span {
              display: block;
              width: 72px;
              height: 1px;
              background-color: #143372;
              position: absolute;
              left: 0;
            }
          }
          .el-input {
            width: 352px;
            height: 52px;
            line-height: 52px;
            font-size: 14px;
            color: #bbbbbb;
          }
          .el-button--default {
            width: 352px;
            height: 50px;
            background-color: #143372;
            color: #ffffff;
          }
          .pass_span {
            width: 352px;
            margin-top: 29px;
            color: #278def;
            font-size: 14px;
            span {
              cursor: pointer;
            }
            span:first-child {
              float: left;
            }
            span:last-child {
              float: right;
            }
          }
        }
      }
    }
  }
}
</style>

